mutation ApprovalTestItemDelete($input: ApprovalTestItemDeleteInput!) {
  approvalTestItemDelete(input: $input) {
    entityDeletes {
      id
      rowTimestamp
    }
  }
}
